function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/model/rootelement
 */
import Element from './element';
/**
 * Type of {@link module:engine/model/element~Element} that is a root of a model tree.
 * @extends module:engine/model/element~Element
 */

var RootElement =
/*#__PURE__*/
function (_Element) {
  _inherits(RootElement, _Element);

  /**
   * Creates root element.
   *
   * @param {module:engine/model/document~Document} document Document that is an owner of this root.
   * @param {String} name Node name.
   * @param {String} [rootName='main'] Unique root name used to identify this root
   * element by {@link module:engine/model/document~Document}.
   */
  function RootElement(document, name) {
    var _this;

    var rootName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'main';

    _classCallCheck(this, RootElement);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RootElement).call(this, name));
    /**
     * Document that is an owner of this root.
     *
     * @private
     * @member {module:engine/model/document~Document}
     */

    _this._document = document;
    /**
     * Unique root name used to identify this root element by {@link module:engine/model/document~Document}.
     *
     * @readonly
     * @member {String}
     */

    _this.rootName = rootName;
    return _this;
  }
  /**
   * {@link module:engine/model/document~Document Document} that owns this root element.
   *
   * @readonly
   * @type {module:engine/model/document~Document|null}
   */


  _createClass(RootElement, [{
    key: "is",

    /**
     * Checks whether this object is of the given.
     *
     *		rootElement.is( 'rootElement' ); // -> true
     *		rootElement.is( 'element' ); // -> true
     *		rootElement.is( 'node' ); // -> true
     *		rootElement.is( 'model:rootElement' ); // -> true
     *		rootElement.is( 'model:element' ); // -> true
     *		rootElement.is( 'model:node' ); // -> true
     *
     *		rootElement.is( 'view:element' ); // -> false
     *		rootElement.is( 'documentFragment' ); // -> false
     *
     * Assuming that the object being checked is an element, you can also check its
     * {@link module:engine/model/element~Element#name name}:
     *
     *		rootElement.is( '$root' ); // -> true if this is a $root element
     *		rootElement.is( 'rootElement', '$root' ); // -> same as above
     *		text.is( '$root' ); -> false
     *
     * {@link module:engine/model/node~Node#is Check the entire list of model objects} which implement the `is()` method.
     *
     * @param {String} type Type to check when `name` parameter is present.
     * Otherwise, it acts like the `name` parameter.
     * @param {String} [name] Element name.
     * @returns {Boolean}
     */
    value: function is(type, name) {
      var cutType = type.replace('model:', '');

      if (!name) {
        return cutType == 'rootElement' || _get(_getPrototypeOf(RootElement.prototype), "is", this).call(this, type);
      } else {
        return cutType == 'rootElement' && name == this.name || _get(_getPrototypeOf(RootElement.prototype), "is", this).call(this, type, name);
      }
    }
    /**
     * Converts `RootElement` instance to `String` containing it's name.
     *
     * @returns {String} `RootElement` instance converted to `String`.
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.rootName;
    } // @if CK_DEBUG_ENGINE // toString() {
    // @if CK_DEBUG_ENGINE // 	return this.rootName;
    // @if CK_DEBUG_ENGINE // }
    // @if CK_DEBUG_ENGINE // log() {
    // @if CK_DEBUG_ENGINE // 	console.log( 'ModelRootElement: ' + this );
    // @if CK_DEBUG_ENGINE // }

  }, {
    key: "document",
    get: function get() {
      return this._document;
    }
  }]);

  return RootElement;
}(Element);

export { RootElement as default };